import styled from "styled-components";
import { Section } from "./Section";
import { Title } from "./Title";
import { Column, Row } from "./Grid";
import { Subtitle } from "./Subtitle";
import { ButtonAnchor } from './Button';
import { Image } from "./Image";

export const NewsletterTeaser = styled(Section)`

    ${Title.H2} {
        margin: 40px;
        margin-bottom: 5px;
    }
    ${Subtitle.H2} {
        margin: 40px;
        margin-top: 0px;
    }
    & p {
        margin: 40px;
    }
    ${ButtonAnchor} {
        min-width: 150px;
        width: 50%;
        margin: 40px;
        margin-top: 0px;
    }
    ${Column} {
        position: relative;
        ${Row} {
            height: 100%;
        }
    }
    ${Image}{
        height: 100%;
        max-width: 80%;
        object-fit: contain;
        position: absolute;
    }
`;